const getters = {
  homeData: state => state.home.homeData,
  hasStatus: state => state.home.hasStatus,
  urlStatus: state => state.home.urlStatus,
  homeIndex: state => state.home.homeIndex
}
export default getters
